<template>
  <div class="home-container">
    <div class="home-content" v-if="lostFlags">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="物品名称" prop="name" style="width: 80%">
                <el-input v-model="searchForm.name" placeholder="请输入物品名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="领取状态"
                prop="status"
                style="width: 80%"
              >
                <el-select
                  clearable filterable
                  v-model="searchForm.status"
                  placeholder="请选择领取状态"
                >
                  <el-option :value="0" label="未领取"></el-option>
                  <el-option :value="1" label="已领取"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button
                size="small"
                @click="onLoad(1)"
                type="primary"
                icon="el-icon-search"
                style="width: 90px"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>        
      <div style="margin: 20px">
        <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addCharacter"
          style="width: 90px"
          >新增</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="recordList"
          style="width: 90px"
          >认领记录</el-button
        >        
      </div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="sort" label="排序" align="center">
        </el-table-column>  
        <el-table-column prop="name" label="物品名称" align="center">
        </el-table-column>
        <el-table-column prop="img" label="物品图片" align="center" width="100px">
          <template slot-scope="scope">
            <img :src="scope.row.img[0]" min-width="70" height="70" />
          </template>
        </el-table-column>
        <el-table-column prop="collectPlace" label="捡拾地点" align="center">
        </el-table-column>    
        <el-table-column prop="collectTime" label="捡拾时间" align="center">
        </el-table-column>   
        <el-table-column prop="status" label="领取状态" align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.status == 0 ? '未领取':'已领取' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="receiveTime" label="领取时间" align="center">
        </el-table-column>   
        <el-table-column prop="phone" label="领取人联系电话" align="center">
        </el-table-column>        
                        
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleClick(scope.row)"
            >查看</el-button>
            <el-button
              type="text"
              size="small"
              @click="receive(scope.row)"
              v-if="scope.row.status == 0"
              >领取</el-button
            >            
            <el-button
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >修改</el-button
            >

            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog :title="modalTitle" :visible.sync="isAddModal" width="50%" @close="close">
        <el-form
          ref="form"
          :model="addData"
          label-width="120px"
          :rules="addDataRules"
          label-position="center"
        >
          <el-form-item label="排序" prop="sort">
            <el-input-number 
              v-model="addData.sort" 
              :precision="0" 
              :step="1" 
              :min="1" 
              placeholder="请输入排序"
              controls-position="right"
              @change="$refs.form.validateField('sort')"
              @blur="$refs.form.validateField('sort')">
            </el-input-number>
          </el-form-item>
          <el-row>
            <el-col :span="24">
              <el-form-item label="物品图片" prop="img">
                <multigraph
                  :url.sync="addData.img"
                  :src="addData.img"
                  :many="9"
                  :width="750"
                  :height="750"
                ></multigraph>
                <div style="color: red">*(建议尺寸750px * 750px)）</div>
              </el-form-item>
            </el-col>
          </el-row>    
           <el-row>
            <el-col :span="12">
              <el-form-item label="物品名称" prop="name">
                <el-input placeholder="请输入物品名称" v-model="addData.name" maxlength="100"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="捡拾时间" prop="collectTime">
                <el-date-picker
                  v-model="addData.collectTime"
                  type="datetime"
                  placeholder="选择日期时间"
                  :picker-options="pickerOptions">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>  
          <el-form-item label="捡拾地点" prop="collectPlace">
            <el-input placeholder="请输入捡拾地点" v-model="addData.collectPlace" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item label="捡拾人姓名" prop="collectUserName">
            <el-input placeholder="请输入捡拾人姓名" v-model="addData.collectUserName" maxlength="20"></el-input>
          </el-form-item>  
          <el-form-item label="捡拾人联系电话" prop="collectPhone">
            <el-input placeholder="请输入捡拾人联系电话" v-model="addData.collectPhone" maxlength="20"></el-input>
          </el-form-item>        
          <el-row>
            <el-col :span="24">
            <el-form-item label="物品描述" prop="content">
              <ueditor v-model="addData.content"></ueditor>
            </el-form-item>  
            </el-col>
          </el-row>            
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <!-- 领取 -->
      <el-dialog :title="diaTitle" :visible.sync="isAddModals" width="50%">
        <el-form
          ref="forms"
          :model="receiveData"
          label-width="130px"
          :rules="receiveDataRules"
          label-position="left"
          style="margin: 0 20px;"
        >
          <div v-if="receiveData.status == 0 && diaTitle == '领取'">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="领取人" prop="userName">
                  <el-input placeholder="请输入领取人姓名" v-model="receiveData.userName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="手机号码" prop="phone">
                    <el-input placeholder="请输入手机号码" v-model="receiveData.phone"></el-input>
                </el-form-item>
              </el-col>
            </el-row>    
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="身份证号" prop="idCard">
                  <el-input placeholder="请输入领取人身份证号" v-model="receiveData.idCard"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="领取时间" prop="receiveTime">
                  <el-date-picker
                    v-model="receiveData.receiveTime"
                    type="datetime"
                    placeholder="选择日期时间">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              
              
            </el-row>    
            <el-row>
              <el-col :span="24">
                <el-form-item label="备注">
                  <el-input v-model="addData.remark" :rows="5" type="textarea" maxlength="500" show-word-limit></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <span style="display: flex; justify-content: center;" class="dialog-footer">
              <el-button @click="isAddModals = false">取 消</el-button>
              <el-button type="primary" @click="bindReceive">确 定</el-button
              >
            </span> 
          </div>
              
          <div>
            <el-form-item label="物品名称：">
              {{ receiveData.name }}
            </el-form-item>            
            <el-form-item label="物品图片：">
              <div v-if="receiveData.img">
                <el-image v-for="(item,i) in receiveData.img" style="width: 100px;height: 100px;margin: 0 10px 10px 0;" fit="cover" :src="item" :preview-src-list="receiveData.img"></el-image>
              </div>
            </el-form-item>   
            <el-form-item label="捡拾地点：">
              {{ receiveData.collectPlace }}
            </el-form-item>   
            <el-form-item label="捡拾时间：">
              {{ receiveData.collectTime }}
            </el-form-item>   
            <el-form-item label="描述：">
              <div v-html="receiveData.content"></div>
            </el-form-item>   
            <el-form-item label="捡拾人姓名：">
              {{ receiveData.collectUserName }}
            </el-form-item>   
            <el-form-item label="捡拾人联系电话：">
              {{ receiveData.collectPhone }}
            </el-form-item>   
            <el-form-item label="创建时间：">
              {{ receiveData.createTime }}
            </el-form-item>
          </div>
          <div v-if="receiveData.status == 1">
            <el-form-item label="领取人姓名：">
              {{ receiveData.userName }}
            </el-form-item>
            <el-form-item label="领取人联系电话：">
              {{ receiveData.phone }}
            </el-form-item>
            <el-form-item label="领取人身份证号：">
              {{ receiveData.idCard }}
            </el-form-item>
            <el-form-item label="领取备注说明：" v-if="receiveData.remark">
              {{ receiveData.remark }}
            </el-form-item>
            <el-form-item label="领取时间：">
              {{ receiveData.receiveTime }}
            </el-form-item>
          </div>
            
        </el-form>
        
      </el-dialog>      
    </div>
    <div v-else>
      <lost-record @recordBack="recordBack"></lost-record>
    </div>
  </div>
</template>

<script>
import upload from "../../components/upload";
import ueditor from "../../components/ueditor"
import multigraph from "../../components/multigraph";
import lostRecord from './components/lostRecord'
import reg from '../../utils/reg'
export default {
  components: {
    upload,
    ueditor,
    lostRecord,
    multigraph
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      searchForm: {
        name: "",
      },
      checkedStr: [], //选中的名称
      checkedIds: [], //选中的id
      isShowTrue: false, //是否显示二级树
      isAddModals:false,
      defaultProps: {
        children: "children",
        value: "id",
        label: "name",
      },
      houseFlag: true,
      modalTitle: "新增",
      diaTitle:'详情',
      props: {
        multiple: true,
        value: "id",
        label: "name",
        checkStrictly: true,
      },
      muneListData: [], //菜单信息
      tableData: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      addData: {
        id: "",
        name: "",
        img: "",
        collectTime: "",
        collectPlace: "",
        content:"",
        collectPhone:'',
        collectUserName:''
      },
      receiveData:{
        userName:'',
        phone:'',
        idCard:'',
        receiveTime:'',
      },
      receiveDataRules: {
        userName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { 
            pattern: /^1[3-9]\d{9}$/, 
            message: "请输入正确的手机号码", 
            trigger: "blur" 
          }
        ],
        receiveTime: [{ required: true, message: "请输入领取时间", trigger: "blur" }],
        idCard: [
          { required: false, message: "请输入身份证号", trigger: "blur" },
          { 
            pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, 
            message: "请输入正确的身份证号", 
            trigger: "blur" 
          }
        ]
      },      
      addDataRules: {
        img: [{ required: true, message: "请上传物品图片", trigger: "blur" }],
        name: [{ required: true, message: "请输入物品名称", trigger: "blur" }],
        collectTime: [{ required: true, message: "请输入捡拾时间", trigger: "blur" }],
        collectPlace: [{ required: true, message: "请输入捡拾地点", trigger: "blur" }],
        collectPhone: [{ required: true, message: "请输入捡拾人姓名联系电话", trigger: "blur" }],
        collectUserName: [{ required: true, message: "请输入捡拾人姓名", trigger: "blur" }],
        content: [{ required: true, message: "请输入物品描述", trigger: "blur" }],
      },
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
      lostFlags:true,
      lostId:''
    };
  },
  created() {},
  mounted() {
    this.onLoad();
  },
  methods: {  
   
    recordBack(){
      this.lostFlags = true
    },
    // 认领记录列表
    recordList(){
      this.lostFlags = false
    },
    // 领取提交
    bindReceive(row){
      this.$refs["forms"].validate((vaild)=>{
        if(vaild){
          this.receiveData.receiveTime = reg.filterTime(this.receiveData.receiveTime)
          let data = {
              id:this.lostId,
              ...this.receiveData
          }
          this.$Apis.lostFoundReceive(data).then((res) => {
            this.isAddModals = false
            if (res.code == 200) {
              this.onLoad();
              this.$message.success(" 成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      })

    },
    handleClick(row) { 
      this.receiveData = JSON.parse(JSON.stringify(row))
      this.diaTitle = '详情'
      this.isAddModals = true
    },

    // 领取弹框
    receive(row){
      for (let item in this.receiveData) {
        this.receiveData[item] = "";
      }
     
      this.receiveData = JSON.parse(JSON.stringify(row))
      this.diaTitle = '领取'
      this.lostId = row.id
      this.isAddModals = true
       this.$refs.forms.resetFields()
    } ,   
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    // 新增角色
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.addData.img = [];
      this.modalTitle = "新增"; 
      this.isAddModal = true;
    },
    close(){
      this.$refs.form.resetFields();
      this.isAddModal = false;
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.addData.img = [];
      
      
    },
    // 修改角色
    updataCharacter(row) {
      this.addData = JSON.parse(JSON.stringify(row));
      this.isAddModal = true;
    },
    //删除角色
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.lostFoundDel({ id }).then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("删除成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          let img = this.addData.img
            .map((res) => (res.url ? res.url : res))
            .join(",");
          var data = {
            id: this.addData.id || "",
            img: img,
            name: this.addData.name,
            collectPlace: this.addData.collectPlace,
            collectTime: this.addData.collectTime || 1,
            content: this.addData.content,
            collectPhone: this.addData.collectPhone,
            collectUserName: this.addData.collectUserName,
            sort: this.addData.sort
          };
          this.$Apis.lostFoundAddUp(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
             
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },

    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad()
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad()
    },
    onLoad(ind) {
      this.isShowloading = true;
      if(ind == 1){
        this.currentPage = 1
      }
      let page = {
        size: this.pageSize,
        current: this.currentPage,
        // status:0,
        ...this.searchForm
      };
      this.$Apis.lostFoundList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          list.forEach((item, ind) => {
            item.img = item.img.split(",");
          });
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
.tree {
  margin-top: 10px;
  width: 300px;
  z-index: 999;
  background-color: #fff;
  padding: 20px;
  height: 200px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
}
</style>